import React, { useState, useRef } from "react";
import { motion, useAnimation } from "framer-motion";
import intgrate from "../../../assets/images/intiailogo.png";
import fiwa from "../../../assets/icons/fiwa.png";
import {
  PartnerSection,
  PartnerContainer,
  PartnerContainerChild,
  Title,
  Subtitle,
  ImageBox,
  StyledButton,
  SliderWrapper,
} from "./Partner.styles";

// Single partner list to be mapped
const partners = [
  {
    id: 1,
    name: "Integr8AI",
    logo: intgrate,
    description:
      "Join forces with industry leaders and innovators. Together, we create extraordinary solutions that push boundaries and define the future.",
    link: "https://integr8human.ai/",
  },
  {
    id: 2,
    name: "Fiwa Sales",
    logo: fiwa,
    description: "Empowering Businesses for Success",
    link: "https://fiwasales.com/",
  },
];

// Animation variants for the slider
const sliderVariants = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};

const Partner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const controls = useAnimation();
  const sliderRef = useRef(null);

  // Function to go to the next slide
  const nextSlide = async () => {
    await controls.start("exit");
    setCurrentIndex((prev) => (prev === partners.length - 1 ? 0 : prev + 1));
    await controls.start("visible");
  };

  // Function to go to the previous slide
  const prevSlide = async () => {
    await controls.start("exit");
    setCurrentIndex((prev) => (prev === 0 ? partners.length - 1 : prev - 1));
    await controls.start("visible");
  };

  // Auto-play functionality
  React.useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000); // Change slide every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <PartnerSection>
      <PartnerContainer>
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="title-container"
        >
          <Title>Meet Our Partners!</Title>
        </motion.div>
        <SliderWrapper>
          <motion.div
            ref={sliderRef}
            variants={sliderVariants}
            initial="hidden"
            animate={controls}
            exit="exit"
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <PartnerContainerChild>
              <ImageBox
                as={motion.div}
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true }}
              >
                <img
                  src={partners[currentIndex].logo}
                  alt={partners[currentIndex].name}
                />
              </ImageBox>
              <motion.div
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <Subtitle>{partners[currentIndex].description}</Subtitle>
              </motion.div>
              <motion.div
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
              >
                <a
                  target="_blank"
                  href={partners[currentIndex].link}
                  style={{ textDecoration: "none" }}
                  rel="noopener noreferrer"
                >
                  <StyledButton>
                    Visit {partners[currentIndex].name}
                  </StyledButton>
                </a>
              </motion.div>
            </PartnerContainerChild>
          </motion.div>

          {/* Navigation Arrows */}
          <motion.button
            onClick={prevSlide}
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "linear-gradient(135deg, #00d285, #00bfff)",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              color: "white",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2,
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            ←
          </motion.button>
          <motion.button
            onClick={nextSlide}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "linear-gradient(135deg, #00d285, #00bfff)",
              border: "none",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              color: "white",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2,
            }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            →
          </motion.button>

          {/* Dots for Navigation */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "1rem",
            }}
          >
            {partners.map((_, index) => (
              <motion.div
                key={index}
                style={{
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  background: index === currentIndex ? "#00bfff" : "#00d285",
                  margin: "0 5px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCurrentIndex(index);
                  controls.start("visible");
                }}
                whileHover={{ scale: 1.2 }}
              />
            ))}
          </div>
        </SliderWrapper>
      </PartnerContainer>
    </PartnerSection>
  );
};

export default Partner;
